import { ProductType } from 'Quotes/types/productTypes';
import { IPriceData, IQuote } from 'Quotes/types/store';
import { findProductTypeLabelForValue } from './findProductTypeLabelForValue';
import { isFTTXConnection } from 'Quotes/types/connectionType';
import { selectIs10GbE } from 'Quotes/selectors';
import { TIER_NAMES } from 'Quotes/QuoteBuilder/components/Price/components/DDOSProtection';

const getProductTypeValue = (selectedPrice: IPriceData, quote: IQuote, productType: ProductType) => {
  if (isFTTXConnection(quote.connectionType)) {
    return `${quote.connectionType} ${findProductTypeLabelForValue(productType, false)}`;
  }

  let suffix = "";
  suffix += (selectedPrice.rapid_activation ? " with Rapid Activation" : "");
  suffix += (quote.ddosProtection ? ` with DDoS Protection (${TIER_NAMES[quote.ddosProtection]})` : "");
  suffix += (selectIs10GbE(selectedPrice) ? " - 10GbE" : "");

  return findProductTypeLabelForValue(productType) + suffix;
};

export default getProductTypeValue;
